import {useDispatch, useSelector} from 'react-redux';

import useDidUpdate from '../../../hooks/useDidUpdate';
import {setIsAemFlexBatteryWarningVisible} from '../../../state/ducks/global';
import {selectIsAemFlexBatteryWarningVisible} from '../../../state/selectors/global';
import {selectIsHolderConnected} from '../../../state/selectors/iotDevice';
import {makeSelectIsYapDeviceInfoReceived} from '../../../state/selectors/yapEncrypted';

const AemFlexBatterySaveWarningHider = () => {
    const dispatch = useDispatch();
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isAemFlexBatteryWarningVisible = useSelector(selectIsAemFlexBatteryWarningVisible);
    const isYapDeviceInfoReceived = useSelector(makeSelectIsYapDeviceInfoReceived());

    useDidUpdate(() => {
        if (!isYapDeviceInfoReceived) return;

        if (isHolderConnected && isAemFlexBatteryWarningVisible) {
            dispatch(setIsAemFlexBatteryWarningVisible(false));
        }
    }, [isHolderConnected]);

    return null;
};

export default AemFlexBatterySaveWarningHider;
